import React, {useState, useEffect} from 'react';

const ActividadDetallesGenerales = (p) =>{
    const inventario  = p.inventario;
    const style = {};
    const classDiv = "col text-s";
    const classSpan = "ml-2 text-m text-bold pt-0 mt-0";
    useEffect(()=>{
        
    },[]);

    if(!inventario) return (<></>);
    
    return (
        <>
        
        <div className="row justify-content-between p-1">
            <div className={classDiv} style={style}>
                <p className="mb-0 pb-0">
                    Rancho:<span className={classSpan}>{inventario.rancho}</span>
                </p>
            </div>
            
            <div className={classDiv} style={style}>
                <p className="mb-0 pb-0">
                    Área:<span className={classSpan}>{inventario.area}</span>
                </p>
            </div>

            {inventario.area!='Vivero' && <div className={classDiv} style={style}>
                <p className="mb-0 pb-0">
                    Válvula:<span className={classSpan}>{inventario.valvula}</span>
                </p>
            </div>}

            <div className={classDiv} style={style}>
                <p className="mb-0 pb-0">
                    Semana:<span className={classSpan}>{inventario.nosemana}</span>
                </p>
            </div>

            <div className={classDiv} style={style}>
                <p className="mb-0 pb-0">
                    Flor:<span className={classSpan}>{inventario.flor}</span>
                </p>
            </div>
        
            <div className={classDiv} style={style}>
                <p className="mb-0 pb-0 text-bold">Columnas del día:</p>
                <p className="pt-0 mt-0 text-xs">Unidades / Horas / personal Necesario</p>
            </div>
        </div>
            
           
        </>
    )
}
    
export default ActividadDetallesGenerales;